import { render, staticRenderFns } from "./CitySelectbox.vue?vue&type=template&id=0635fa98&"
import script from "./CitySelectbox.vue?vue&type=script&lang=js&"
export * from "./CitySelectbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports